import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var getPropValues = function (value) { return !!value && value; };
var GridComponent = /** @class */ (function (_super) {
    __extends(GridComponent, _super);
    function GridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GridComponent.prototype, "styles", {
        /**
         * Return CSS variables based on the props
         */
        get: function () {
            var styleArray = [
                { prefix: '-cols', value: getPropValues(this.cols) },
                { prefix: '-sm-cols', value: getPropValues(this.colsSm) },
                { prefix: '-md-cols', value: getPropValues(this.colsMd) },
                { prefix: '-lg-cols', value: getPropValues(this.colsLg) },
                { prefix: '-xl-cols', value: getPropValues(this.colsXl) },
                { prefix: '-gap', value: getPropValues(this.gap) },
                {
                    prefix: '-gap-horizontal',
                    value: getPropValues(this.horizontalGap),
                },
                { prefix: '-gap-vertical', value: getPropValues(this.verticalGap) },
            ];
            var finalStyles = {};
            styleArray.forEach(function (_a) {
                var prefix = _a.prefix, value = _a.value;
                if (value) {
                    finalStyles["--grid" + prefix] = value;
                }
            });
            return finalStyles;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "cols", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "colsSm", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "colsMd", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "colsLg", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "colsXl", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "gap", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "horizontalGap", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], GridComponent.prototype, "verticalGap", void 0);
    GridComponent = __decorate([
        Component({
            name: 'ui-grid',
        })
    ], GridComponent);
    return GridComponent;
}(Mixins(MagicConfigMixin)));

export default GridComponent;
